import React from 'react';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    maxHeight: 600,
    minHeight: 300,
    backgroundColor: 'white',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
    overflow: 'auto',
    borderRadius: 8,
    padding: '24px',
    zIndex: 1000,
};

const backdropStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.5)',
    zIndex: 999,
};

const Modal = ({
    open,
    onClose,
    reason,
    setReason,
    label,
    subheading,
    showTextBox = false,
    primaryButton,   // React node for primary button (e.g. Confirm Reject)
    secondaryButton, // React node for secondary button (e.g. Cancel)
}) => {
    if (!open) return null;

    return (
        <>
            <div style={backdropStyle} onClick={onClose} />
            <div
                style={modalStyle}
                role="dialog"
                aria-modal="true"
                aria-labelledby="modal-label"
                onClick={e => e.stopPropagation()}
            >
                <h2 id="modal-label" style={{ marginBottom: '12px' }}>{label}</h2>
                <p style={{ marginBottom: '20px' }}>{subheading}</p>
                {showTextBox && (
                    <textarea
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        placeholder="Enter Reason"
                        style={{
                            width: '100%',
                            height: '100px',
                            padding: '8px',
                            fontSize: '16px',
                            borderRadius: '4px',
                            border: '1px solid #ccc',
                            resize: 'vertical'
                        }}
                    />
                )}
                <div style={{ marginTop: '20px', textAlign: 'right', display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                    {secondaryButton}
                    {primaryButton}
                </div>
            </div>
        </>
    );
};

export default Modal;
